import { render, staticRenderFns } from "./vue-randomator.vue?vue&type=template&id=52908911&scoped=true&"
import script from "./vue-randomator.vue?vue&type=script&lang=js&"
export * from "./vue-randomator.vue?vue&type=script&lang=js&"
import style0 from "./vue-randomator.vue?vue&type=style&index=0&id=52908911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52908911",
  null
  
)

export default component.exports